import { create } from 'zustand';
import { getDefaultYear } from '../common/helper_functions';
// import { persist } from 'zustand/middleware';
import _ from 'lodash';
import { styleOptions, viewOptions } from '../common/mappings';
// import { useMemo } from 'react';
// Zustand global state management store.
// For specific / niche things, we should remove them from the global store and put them into specific context.


export const useCompStore = create(
  (set, get) => ({
    subjLat: '', // Initial value for subjLat
    subjLong: '', // Initial value for subjLong
    AvgPrice: 0,
    setAvgPrice: (value) => set((state) => {
      if (!_.isEqual(state.AvgPrice, value)) {
        return { AvgPrice: value };
      }
      return state;
    }),
    setAllData: (value) => set((state) => {
      if (!_.isEqual(state.allData, value)) {
        return { allData: value };
      }
      return state;
    }),
    setSubjLat: (value) => set((state) => {
      if (!_.isEqual(state.subjLat, value)) {
        return { subjLat: value };
      }
      return state;
    }), // Setter for subjLat
    setSubjLong: (value) => set((state) => {
      if (!_.isEqual(state.subjLong, value)) {
        return { subjLong: value };
      }
      return state;
    }), // Setter for subjLong
    adjustments: [],
    setAdjustments: (value) => set((state) => {
      if (!_.isEqual(state.adjustments, value)) {
        return { adjustments: value };
      }
      return state;
    }),
    sortOrder: 'asc',
    setSortOrder: (value) => set((state) => {
      if (!_.isEqual(state.sortOrder, value)) {
        return { sortOrder: value };
      }
      return state;
    }),
    originalOptimComps: [],
    setOriginalOptimComps: (value) => set((state) => {
      if (!_.isEqual(state.originalOptimComps, value)) {
        return { originalOptimComps: value };
      }
      return state;
    }),
    originalCompList: [],
    setOriginalCompList: (value) => set((state) => {
      if (!_.isEqual(state.originalCompList, value)) {
        return { originalCompList: value };
      }
      return state;
    })
  }),
  {
    name: 'Compsheet', // Name for the persisted state
  }
);

export const usePersistedDataStore = create(
  (set, get) => ({
    reportType: 'standard',
    setReportType: (value) => set((state) => {
      if (!_.isEqual(state.reportType, value)) {
        return { reportType: value };
      }
      return state;
    }),
    dataAnalysisResult: [],
    setDataAnalysisResult: (value) => set((state) => {
      if (!_.isEqual(state.dataAnalysisResult, value)) {
        return { dataAnalysisResult: value };
      }
      return state;
    }),
    dataAnalysisColumns: [],
    setDataAnalysisColumns: (value) => set((state) => {
      if (!_.isEqual(state.dataAnalysisColumns, value)) {
        return { dataAnalysisColumns: value };
      }
      return state;
    }),
    dataAnalysisFilterModel: null,
    setDataAnalysisFilterModel: (value) => set((state) => {
      if (!_.isEqual(state.dataAnalysisFilterModel, value)) {
        return { dataAnalysisFilterModel: value };
      }
      return state;
    }),
    badDataFlags: {
      data: ['Style', 'Sqft', 'Acres', 'YearBuilt', 'Bath', 'Address', 'PropertyAssessment', 'IFMV', 'PhotoURL', 'Latitude', 'Longitude', 'TotalGarageCap'],
      outliers: []
    },
    setBadDataFlags: (value) => set((state) => {
      if (!_.isEqual(state.badDataFlags, value)) {
        return { badDataFlags: value };
      }
      return state;
    }),
    flagType: 'data',
    setFlagType: (value) => set((state) => {
      if (!_.isEqual(state.flagType, value)) {
        return { flagType: value };
      }
      return state;
    }),
    negotiationObj: { cases: [], county: 'All', countyString: '', municipality: 'All', village: 'All', TaxYear: getDefaultYear(), courtDate: 'All', MuniCode: null, courtDateSelectedMuni: null },
    setNegotiationObj: (value) => set((state) => {
      if (!_.isEqual(state.negotiationObj, value)) {
        return { negotiationObj: value };
      }
      return state;
    }),
    negotiationObjVersion: 0,
    setNegotiationObjVersion: (value) => set((state) => {
      if (state.negotiationObjVersion !== value) {
        return { negotiationObjVersion: value };
      }
      return state;
    }),
    emailingOffers: false,
    setEmailingOffers: (value) => set((state) => {
      if (!_.isEqual(state.emailingOffers, value)) {
        return { emailingOffers: value };
      }
      return state;
    }),
    workupReportType: 'fnmaSummary',
    setWorkupReportType: (value) => set((state) => {
      if (state.workupReportType !== value) {
        return { workupReportType: value };
      }
      return state;
    }),
    includeCompsInOffersSpreadsheet: true,
    setIncludeCompsInOffersSpreadsheet: (value) => set((state) => {
      if (state.includeCompsInOffersSpreadsheet !== value) {
        return { includeCompsInOffersSpreadsheet: value };
      }
      return state;
    }),
    incrementNegotiationObjVersion: () => set((state) => ({
      negotiationObjVersion: state.negotiationObjVersion + 1
    })),
    compLookupCacheInvalidationVersion: 0,
    incrementCompLookupCacheInvalidation: () => set((state) => ({
      compLookupCacheInvalidationVersion: state.compLookupCacheInvalidationVersion + 1
    })),
    /** Bumped when comp-grid unsaved ref changes so SharedGridToolbar re-reads it without MuiTable setState. */
    caseReviewToolbarRevision: 0,
    bumpCaseReviewToolbarRevision: () => set((state) => ({
      caseReviewToolbarRevision: state.caseReviewToolbarRevision + 1,
    })),
    refreshMunicipalResults: null,
    setRefreshMunicipalResults: (fn) => set({ refreshMunicipalResults: fn }),
    /** Current-year achieved bucket (settled cases only) plus resultType, from muni results or the algo offer refresh. */
    settledPerformance: null,
    setSettledPerformance: (value) => set({ settledPerformance: value }),
    settledPerformanceLoading: false,
    setSettledPerformanceLoading: (value) => set({ settledPerformanceLoading: value }),
    marketingResponse: [],
    setMarketingResponse: (value) => set((state) => {
      if (!_.isEqual(state.marketingResponse, value)) {
        return { marketingResponse: value };
      }
      return state;
    }),
    evidenceComparisonData: {},
    setEvidenceComparisonData: (value) => set((state) => {
      if (!_.isEqual(state.evidenceComparisonData, value)) {
        return { evidenceComparisonData: value };
      }
      return state;
    }),
    totalCases: null,
    setTotalCases: (value) => set((state) => {
      if (!_.isEqual(state.totalCases, value)) {
        return { totalCases: value };
      }
      return state;
    }),
    
    timeAdjustmentSettings: { timeAdjustmentValue: null, saleDateType: 'title' },
    setTimeAdjustmentSettings: (value) => set((state) => {
      return { timeAdjustmentSettings: value };
    }),
    caseNotes: [],
    setCaseNotes: (value) => set((state) => {
      if (!_.isEqual(state.caseNotes, value)) {
        return { caseNotes: value };
      }
      return state;
    }),
    fetchIteration: 0,
    setFetchIteration: (value) => set((state) => {
      if (!_.isEqual(state.fetchIteration, value)) {
        return { fetchIteration: value };
      }
      return state;
    }),
    compSheet: '', // Initial value for compSheet
    setCompSheet: (newSheet) => set(() => {
      // Use deep comparison to avoid unnecessary updates
        return { compSheet: newSheet };
    }),
    optimizedComps: [], // Initial value for compSheet
    setOptimizedComps: (value) => set(() => {
        return { optimizedComps: value };
      }), // Setter for compSheet
    courtComps: [],
    setCourtComps: (value) => set(() => {
        return { courtComps: value };
    }),
    editedValues: {},
    setEditedValues: (value) => set(()=>{
      return { editedValues: value };
    }),
    optimizedCompsB: [],
    setOptimizedCompsB: (value) => set(() => {
        return { optimizedCompsB: value };
    }),
    compSheetB: [],
    setCompSheetB: (value) => set(() => {
        return { compSheetB: value };
    }),
    upcomingCourtDates: [],
    setUpcomingCourtDates: (value) => set((state) => {
      if (!_.isEqual(state.upcomingCourtDates, value)) {
        return { upcomingCourtDates: value };
      }
      return state;
    }),
    fetchLoad: false,
    setFetchLoad: (value) => set((state) => {
      if (!_.isEqual(state.fetchLoad, value)) {
        return { fetchLoad: value };
      }
      return state;
    }),      
    caseNumber: 0,
    setCaseNumber: (caseNum) => set((state) => {
      if (!_.isEqual(state.caseNumber, caseNum)) {
        return { caseNumber: caseNum };
      }
      return state;
    }),
    evalDate: '',
    setEvalDate: (evalDate) => set((state) => {
      if (!_.isEqual(state.evalDate, evalDate)) {
        return { evalDate: evalDate };
      }
      return state;
    }),
    rar: '',
    setRar: (rar) => set((state) => {
      if (!_.isEqual(state.rar, rar)) {
        return { rar: rar };
      }
      return state;
    }),
    eq: '',
    setEq: (eq) => set((state) => {
      if (!_.isEqual(state.eq, eq)) {
        return { eq: eq };
      }
      return state;
    }),
    courtMunis: [],
    setCourtMunis: (courtMunis) => set((state) => {
      if (!_.isEqual(state.courtMunis, courtMunis)) {
        return { courtMunis: courtMunis };
      }
      return state;
    }),
    filterIndexes: undefined,
    setFilterIndexes: (value) => set((state) => {
      if (!_.isEqual(state.filterIndexes, value)) {
        return { filterIndexes: value };
      }
      return state;
    }),
    styleOptions: styleOptions,
    viewOptions: viewOptions,
    termsAccepted: false,
    setTermsAccepted: (value) => set((state) => {
      if (!_.isEqual(state.termsAccepted, value)) {
        return { termsAccepted: value };
      }
      return state;
    }),
    showPropertyinfo: null,
    setShowPropertyinfo: (value) => set((state) => {
      if (!_.isEqual(state.showPropertyinfo, value)) {
        return { showPropertyinfo: value };
      }
      return state;
    }),
    isFetching: false,
    setIsFetching: (value) => set((state) => {
      if (!_.isEqual(state.isFetching, value)) {
        return { isFetching: value };
      }
      return state;
    }),
    isEnrichingClientCases: false,
    setIsEnrichingClientCases: (value) => set((state) => {
      if (!_.isEqual(state.isEnrichingClientCases, value)) {
        return { isEnrichingClientCases: value };
      }
      return state;
    }),
    s3UploadResult: null,
    setS3UploadResult: (value) => set((state) => {
      if (!_.isEqual(state.s3UploadResult, value)) {
        return { s3UploadResult: value };
      }
      return state;
    }),
    settlementRounding: 0,
    setSettlementRounding: (value) => set((state) => {
      if (!_.isEqual(state.settlementRounding, value)) {
        return { settlementRounding: value };
      }
      return state;
    }),
    settlementIsAVMode: false,
    setSettlementIsAVMode: (value) => set((state) => {
      if (state.settlementIsAVMode !== value) {
        return { settlementIsAVMode: value };
      }
      return state;
    }),
    settlementRoundingMuniCode: null,
    setSettlementRoundingMuniCode: (value) => set((state) => {
      if (!_.isEqual(state.settlementRoundingMuniCode, value)) {
        return { settlementRoundingMuniCode: value };
      }
      return state;
    }),
    downloadStips: false,
    setDownloadStips: (value) => set((state) => {
      if (state.downloadStips !== value) {
        return { downloadStips: value };
      }
      return state;
    }),
    stipsDownloadInFlight: false,
    setStipsDownloadInFlight: (value) => set((state) => (
      state.stipsDownloadInFlight === !!value ? state : { stipsDownloadInFlight: !!value }
    )),
    townOfferProdCheckbox: false,
    setTownOfferProdCheckbox: (value) => set((state) => {
      if (!_.isEqual(state.townOfferProdCheckbox, value)) {
        return { townOfferProdCheckbox: value };
      }
      return state;
    }),
    summaryCaseTableSortModel: [],
    setSummaryCaseTableSortModel: (value) => set((state) => {
      if (!_.isEqual(state.summaryCaseTableSortModel, value)) {
        return { summaryCaseTableSortModel: value };
      }
      return state;
    }),
    summaryCaseTableOriginalParcelIds: null,
    setSummaryCaseTableOriginalParcelIds: (value) => set((state) => {
      if (!_.isEqual(state.summaryCaseTableOriginalParcelIds, value)) {
        return { summaryCaseTableOriginalParcelIds: value };
      }
      return state;
    }),
    summaryCaseTableStatusFilter: 'all',
    setSummaryCaseTableStatusFilter: (value) => set((state) => {
      if (state.summaryCaseTableStatusFilter !== value) {
        return { summaryCaseTableStatusFilter: value };
      }
      return state;
    }),
    summaryCaseTableActiveStage: 'all',
    setSummaryCaseTableActiveStage: (value) => set((state) => {
      if (state.summaryCaseTableActiveStage !== value) {
        return { summaryCaseTableActiveStage: value };
      }
      return state;
    }),
    workupRegeneratingByParcel: {},
    setWorkupRegeneratingByParcel: (parcelId, value) => set((state) => ({
      workupRegeneratingByParcel: {
        ...state.workupRegeneratingByParcel,
        [parcelId]: value,
      },
    })),
    clearAllWorkupRegenerating: () => set(() => ({
      workupRegeneratingByParcel: {},
    })),
    loadingModal: null,
    setLoadingModal: (value) => set((state) => {
      if (!_.isEqual(state.loadingModal, value)) {
        return { loadingModal: value };
      }
      return state;
    }),
    visualizationUseRebuiltViz: true,
    setVisualizationUseRebuiltViz: (value) => set((state) => {
      if (state.visualizationUseRebuiltViz !== value) {
        return { visualizationUseRebuiltViz: value };
      }
      return state;
    }),
}),
  {
    name: 'Persisted', // Name for the persisted state
  }
);

export const useLocalDataStore = create(
  (set) => ({
    sortedFactors: [],
    setSortedFactors: (factor) => set((state) => {
      if (!_.isEqual(state.sortedFactors, factor)) {
        return { sortedFactors: factor };
      }
      return state;
    }),
    modelWeights: {},
    setModelWeights: (weightObj) => set((state) => {
      if (!_.isEqual(state.modelWeights, weightObj)) {
        return { modelWeights: { ...weightObj } };
      }
      return state;
    }),
    processedCount: 1,
    setProcessedCount: (count) => set((state) => {
      if (!_.isEqual(state.processedCount, count)) {
        return { processedCount: count };
      }
      return state;
    }),

    settingsUpdated: false,
    setSettingsUpdated: (settingsUpdated) => set((state) => {
      if (!_.isEqual(state.settingsUpdated, settingsUpdated)) {
        return { settingsUpdated: settingsUpdated };
      }
      return state;
    }),
    
    optimizationWeights: {},
    setOptimizationWeights: (weightObj) => set((state) => {
      if (!_.isEqual(state.optimizationWeights, weightObj)) {
        return { optimizationWeights: { ...weightObj } };
      }
      return state;
    }),
    reviewPage: false,
    setReviewPage: (value) => set((state) => {
      if (!_.isEqual(state.reviewPage, value)) {
        return { reviewPage: value };
      }
      return state;
    }),
    unsentOffersLeaveDialogOpen: false,
    setUnsentOffersLeaveDialogOpen: (value) => set((state) => {
      if (state.unsentOffersLeaveDialogOpen !== value) {
        return { unsentOffersLeaveDialogOpen: value };
      }
      return state;
    }),
    view: 'regular',
    setView: (value) => set((state) => {
      if (!_.isEqual(state.view, value)) {
        return { view: value };
      }
      return state;
    }),
    sidebarOpen: false,
    setSidebarOpen: (open) => set((state) => {
      if (!_.isEqual(state.sidebarOpen, open)) {
        return { sidebarOpen: open };
      }
      return state;
    }),
    rfResults: {},
    setRfResults: (result) => set((state) => {
      if (!_.isEqual(state.rfResults, result)) {
        return { rfResults: result };
      }
      return state;
    })
  }),
  {
    name: 'localDataStore', // Optional name for the persisted store
    version: 1, // Optional version number for the persisted data
  }
);

export const useAdminSettingsStore = create(
  (set) => ({
    selectedFilter: 'Sales Only',
    setSelectedFilter: (filter) => set((state) => {
      if (!_.isEqual(state.selectedFilter, filter)) {
        return { selectedFilter: filter };
      }
      return state;
    }),
    salesCompReport: false,
    setSalesCompReport: (filter) => set((state) => {
      if (!_.isEqual(state.salesCompReport, filter)) {
        return { salesCompReport: filter };
      }
      return state;
    }),
    state: 'NY',
    setState: (state) => set((state) => {
      if (!_.isEqual(state.state, state)) {
        return { state: state };
      }
      return state;
    }),
    map: true,
    setMap: (map) => set((state) => {
      if (!_.isEqual(state.map, map)) {
        return { map: map };
      }
      return state;
    }),
    user: null,
    setUser: (user) => set((state) => {
      if (!_.isEqual(state.user, user)) {
        return { user: user };
      }
      return state;
    }),
    errorState: '',
    setErrorState: (errorState) => set((state) => {
      if (!_.isEqual(state.errorState, errorState)) {
        return { errorState: errorState };
      }
      return state;
    }),
    popup: false,
    setPopup: (popup) => set((state) => {
      if (!_.isEqual(state.popup, popup)) {
        return { popup: popup };
      }
      return state;
    }),
    defaultComps: 5,
    setDefaultComps: (defaultComps) => set((state) => {
      if (!_.isEqual(state.defaultComps, defaultComps)) {
        return { defaultComps: defaultComps };
      }
      return state;
    }),

    // SET THIS TO TRUE FOR YOUR DEMO
    showSettledCases: false,
    setShowSettledCases: (showSettledCases) => set((state) => {
      if (!_.isEqual(state.showSettledCases, showSettledCases)) {
        return { showSettledCases: showSettledCases };
      }
      return state;
    }),
    defaultNumCases: null,
    setDefaultNumCases: (defaultNumCases) => set((state) => {
      if (!_.isEqual(state.defaultNumCases, defaultNumCases)) {
        return { defaultNumCases: defaultNumCases };
      }
      return state;
    }),
    manualReview: false,
    setManualReview: (manualReview) => set((state) => {
      if (!_.isEqual(state.manualReview, manualReview)) {
        return { manualReview: manualReview };
      }
      return state;
    })
  }),
  {
    name: 'adminSettingsStore', // Optional name for the persisted store
    version: 1, // Optional version number for the persisted data
  }
);
